import { render, staticRenderFns } from "./dxy-step.vue?vue&type=template&id=ac71c8ec&scoped=true&"
import script from "./dxy-step.vue?vue&type=script&lang=js&"
export * from "./dxy-step.vue?vue&type=script&lang=js&"
import style0 from "./dxy-step.vue?vue&type=style&index=0&id=ac71c8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71c8ec",
  null
  
)

component.options.__file = "dxy-step.vue"
export default component.exports